import axios from "../common/Axios";

// UTIL FOR SERVICE

function getQueryString(params) {
  return Object.keys(params)
    .map(key => {
      if (!params[key] && typeof params[key] !== "boolean") {
        return null;
      }
      return `${key}=${params[key]}`;
    })
    .join("&");
}

//SOLICITUDES

function getContratosEntidades(fechaInicio, fechaFinal, sociedad) {
  return axios.get(
    `/spac/contratosCargadorEnSolicitud?fechaDesde=${
      fechaInicio
    }&fechaHasta=${
      fechaFinal
    }${
      sociedad && sociedad !== "Todas" ? `&sociedad=${sociedad}` : ""
    }`
  );
}

function getSolicitudesSociedades() {
  return axios.get(`/spac/solicitudes/sociedades`);
}

function getSolicitudesEnHora(
  asc,
  fechaInicial,
  fechaFinal,
  contrato,
  codigoSociedad,
  page,
  sortby,
  size
) {
  return axios.get(
    `/spac/solicitudes?${asc ? "asc=" + asc + "&" : ""}${
      contrato ? "contrato=" + contrato + "&" : ""
    }${
      codigoSociedad ? "sociedad=" + codigoSociedad + "&" : ""
    }fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}${
      page ? "&page=" + page : ""
    }${sortby ? "&sortby=" + sortby : ""}${size ? "&size=" + size : ""}`
  );
}

function getSolicitudesFueraDeHora(
  asc,
  fechaInicial,
  fechaFinal,
  contrato,
  codigoSociedad,
  page,
  sortby,
  size
) {
  return axios.get(
    `/spac/solicitudes/fueradehora?${asc ? "asc=" + asc + "&" : ""}${
      contrato ? "contrato=" + contrato + "&" : ""
    }${
      codigoSociedad ? "sociedad=" + codigoSociedad + "&" : ""
    }fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}${
      page ? "&page=" + page : ""
    }${sortby ? "&sortby=" + sortby : ""}${size ? "&size=" + size : ""}`
  );
}

function getEDI(solicitudes) {
  return axios.post(`/spac/solicitudes/generacionedi`, solicitudes, {
    responseType: "text"
  });
}

function deleteSolicitud(enHora, solicitudesToRemove) {
  return axios.delete(`/spac/solicitudes?enHora=${enHora}`, {
    data: solicitudesToRemove
  });
}

function checkContratoActivo(contrato) {
  return axios.get(
    `/spac/contratosCargadorEnSolicitud/isActivo?contrato=${contrato}`
  );
}

function validarCaminos(fullDtoCamino) {
  return axios.post("/spac/solicitudes/validarcaminos", fullDtoCamino);
}

function validarCamino(solicitud, camino) {
    return axios.post("/spac/solicitudes/validarcamino", {solicitud, camino});
}

//SOLICITUD DETALLE

function getDetalleSolicitud(contrato, solicitud, enHora) {
  return axios.get(
    `/spac/solicitudes/${contrato}/${solicitud}?enHora=${enHora}`
  );
}

function copySolicitud(contrato, solicitud, enHora, fechaInicial, fechaFinal) {
  return axios.get(
    `/spac/solicitudes/copiar/${contrato}/${solicitud}?enHora=${enHora}&fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`
  );
}

function actualizarCopiaSolicitud(contrato, solicitud, enHora, numeroSolicitud, fechaInicial, fechaFinal) {
  return axios.get(
    `/spac/solicitudes/actualizar/${contrato}/${solicitud}?enHora=${enHora}&numeroSolicitud=${numeroSolicitud}&fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`
  );
}

function saveSolicitud(datos) {
  return axios.post(`/spac/solicitudes`, datos);
}

function getCaminos(contrato, fechaDesde, fechaHasta) {
  return axios.get(
    `/spac/contratosCargadorEnSolicitud/${contrato}/caminosvigentes?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
  );
}  

function getPuntos(codigoContrato, codigoZona, tipoZona) {
  return axios.get(
    `/spac/puntos?codigoContrato=${codigoContrato}&codigoZona=${codigoZona}&tipoZona=${tipoZona}`
  );
}

function getPuntosByZonaTipoZonaAndFechas(codigoContrato, codigoZona, tipoZona, inicial, final) {
  return axios.get(
      `/spac/puntos/filtrar?codigoContrato=${codigoContrato}&codigoZona=${codigoZona}&tipoZona=${tipoZona}&inicio=${inicial}&fin=${final}`
  );
}

function getReferentes() {
  return axios.get("/spac/referente");
}

//SOLICITUD EDI

function importEdiSolicitudes(file) {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post("/spac/solicitudEdi/importEdi", formData, {
    headers: {
      "content-type": "multipart/form-data"
    }
  });
}

function reportSolicitudesEdi(solicitudes, type) {
  return axios.post(
    `/spac/solicitudEdi/report?reportType=${type}`,
    solicitudes,
    {
      responseType: "blob"
    }
  );
}

function postSaveLote(solicitud) {
  return axios.post(`/spac/solicitudEdi/saveLote`, solicitud);
}

//CONFIRMACIONES

function getContratosOperadores(fechaInicial, fechaFinal) {
  return axios.get(
    `/spac/contratoOperador?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`
  );
}

function getEntidadesLegales(fechaInicial, fechaFinal) {
  return axios.get(
    `/spac/entidadesLegales?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`
  );
}

function getSociedadesConfirmaciones() {
  return axios.get(`/spac/confirmaciones/sociedades`);
}

function getEntidadesLegalesConfirmaciones(fechaInicial, fechaFinal) {
  return axios.get(
    `/spac/confirmaciones/entidadesLegales?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`
  );
}

function getConfirmacionesEnHora(
  asc,
  fechaInicial,
  fechaFinal,
  contrato,
  entidadlegal,
  sociedad,
  page,
  sortby,
  size
) {
  const contratoVal = typeof contrato === 'object' && contrato !== null 
    ? (contrato.codigo || contrato[0]) 
    : contrato;

  return axios.get(
    `/spac/confirmaciones?${asc ? "asc=" + asc + "&" : ""}${
      contratoVal ? "contrato=" + contratoVal + "&" : ""
    }${entidadlegal ? "entidadLegal=" + entidadlegal + "&" : ""}${
      sociedad ? "sociedad=" + sociedad + "&" : ""
    }fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}${
      page ? "&page=" + page : ""
    }${sortby ? "&sortby=" + sortby : ""}${size ? "&size=" + size : ""}`
  );
}

function getConfirmacionesFueraDeHora(
  asc,
  fechaInicial,
  fechaFinal,
  contrato,
  entidadlegal,
  sociedad,
  page,
  sortby,
  size
) {
  const contratoVal = typeof contrato === 'object' && contrato !== null 
    ? (contrato.codigo || contrato[0]) 
    : contrato;

  return axios.get(
    `/spac/confirmaciones/fueradehora?${asc ? "asc=" + asc + "&" : ""}${
      contratoVal ? "contrato=" + contratoVal + "&" : ""
    }${entidadlegal ? "entidadLegal=" + entidadlegal + "&" : ""}${
      sociedad ? "sociedad=" + sociedad + "&" : ""
    }fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}${
      page ? "&page=" + page : ""
    }${sortby ? "&sortby=" + sortby : ""}${size ? "&size=" + size : ""}`
  );
}

function generarEDIC(confirmaciones) {
  return axios.post(`/spac/confirmaciones/generacionedi`, confirmaciones, {
    responseType: "text"
  });
}

function deleteConfirmaciones(enHora, confirmacionesToRemove) {
  return axios.delete(`/spac/confirmaciones?enHora=${enHora}`, {
    data: confirmacionesToRemove
  });
}

function getReferentesConfirmaciones(punto, fecha, rolPunto, contratoCargador, contratoOperador) {
  return axios.get(
    `/spac/referente/referentes?punto=${punto}&fecha=${fecha}&rolPunto=${rolPunto}&contratoCargador=${contratoCargador}&contratoOperador=${contratoOperador}`
  );
}

//CONFIRMACION EDI

function importEdiConfirmaciones(file) {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post("/spac/confirmacionEdi/importEdi", formData, {
    headers: {
      "content-type": "multipart/form-data"
    }
  });
}

function reportConfirmacionEdi(confirmaciones, type) {
  return axios.post(
    `/spac/confirmacionEdi/report?reportType=${type}`,
    confirmaciones,
    {
      responseType: "blob"
    }
  );
}

function saveConfirmacionEdi(confirmacion) {
  return axios.post(`/spac/confirmacionEdi/saveLote`, confirmacion);
}

// CONFIRMACIONES DETALLES

function getDetalleConfirmacion(contrato, confirmacion, enHora, readOnlyMode) {
  return axios.get(
    `/spac/confirmaciones/${contrato}/${confirmacion}?enHora=${enHora}&readOnlyMode=${readOnlyMode}`
  );
}

function copyConfirmacion(contrato, confirmacion, enHora) {
  return axios.get(
    `/spac/confirmaciones/copiar/${contrato}/${confirmacion}?enHora=${enHora}`
  );
}

function getPuntosConfirmacion(contrato, fechaFinal, fechaInicial) {
  return axios.get(
    `/spac/confirmaciones/puntos/${contrato}?fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}`
  );
}

function saveConfirmacion(datos) {
  return axios.post(`/spac/confirmaciones`, datos);
}

function getContratosCargadores(fechaDesde, fechaHasta) {
  return axios.get(
    `/spac/contratosCargadorEnSolicitud/todos?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
  );
}

function getCantidadesSolicitadas(nroPunto, fecha) {
  return axios.get(`/spac/puntos/${nroPunto}/cantidades?fecha=${fecha}`);
}

function getTipoSeleccionContrato(fecha,itemsConfirmacion) {
  return axios.post(`/spac/confirmaciones/tipoSeleccionContratoItems?fecha=${fecha}`, itemsConfirmacion);
}

function getTipoSeleccionContratoCantidadeswithpunto(fecha,punto, itemsConfirmacion) {
  return axios.post(`/spac/confirmaciones/tipoSeleccionContratoCantidadesConPuntos?fecha=${fecha}&punto=${punto}`, itemsConfirmacion);
}

function erroresMeg(contrato, nroConfirmacion, enHora, errores) {
  return axios.post(
    `/spac/confirmaciones/erroresMegReport/${contrato}/${nroConfirmacion}?enHora=${enHora}`,
    errores,
    {
      responseType: "blob"
    }
  );
}

// PROGRAMACION ASIGNACION

function getPuntosAsignacion() {
  return axios.get(`/spac/puntos/combo`);
}

function generarEDIAsignacion(data) {
  return axios.post(`/spac/generacionEDI/asignacionProgramacion`, data, {
    responseType: "text"
  });
}

// PROGRAMACION HISTORICOS

function getHistoricosLotes(fecha) {
  return axios.get(`/spac/programacion/historicos/lotes?fecha=${fecha}`);
}

function getHistoricosContratos(fecha, nroLote, tipoHistorico) {
  return axios.get(
    `/spac/programacion/historicos/contratos?fecha=${fecha}&nroLote=${nroLote}&tipoHistorico=${tipoHistorico}`
  );
}

function getHistoricosPuntos(fecha, nroLote, tipoHistorico) {
  return axios.get(
    `/spac/programacion/historicos/puntos?fecha=${fecha}&nroLote=${nroLote}&tipoHistorico=${tipoHistorico}`
  );
}

// SOLICITUDES

function getHistoricosSolicitud(fecha, nroLote, contrato) {
  return axios.get(
    `/spac/programacion/historicos/solicitud?contrato=${contrato}&fecha=${fecha}&nroLote=${nroLote}`
  );
}

function generarEDISolicitudes(data) {
  return axios.post(`/spac/programacion/historicos/solicitudEdi`, data, {
    responseType: "text"
  });
}

// CONFIRMACIONES

function getHistoricosConfirmacion(fecha, nroLote, contrato) {
  return axios.get(
    `/spac/programacion/historicos/confirmacion?contrato=${contrato}&fecha=${fecha}&nroLote=${nroLote}`
  );
}

function generarEDIConfirmaciones(data) {
  return axios.post(`/spac/programacion/historicos/confirmacionEdi`, data, {
    responseType: "text"
  });
}

// POR CAMINOS

function getHistoricosProgramacionCaminos(fecha, nroLote, contrato) {
  return axios.get(
    `/spac/programacion/historicos/programacionPorCaminos?contrato=${contrato}&fecha=${fecha}&nroLote=${nroLote}`
  );
}

function generarEDICaminos(data) {
  return axios.post(
    `/spac/programacion/historicos/programacionCaminosEdi`,
    data,
    {
      responseType: "text"
    }
  );
}

// POR PUNTOS

function getHistoricosProgramacionPuntos(fecha, nroLote, nroPunto) {
  return axios.get(
    `/spac/programacion/historicos/programacionPorPuntos?fecha=${fecha}&nroLote=${nroLote}&nroPunto=${nroPunto}`
  );
}

// CAPACIDAD

function getHistoricosCapacidadPuntos(fecha, nroLote, nroPunto) {
  return axios.get(
    `/spac/programacion/historicos/capacidadDelPuntos?fecha=${fecha}&nroLote=${nroLote}&nroPunto=${nroPunto}`
  );
}

// PROGRAMACION POR PUNTOS

function getProgramacionPorPunto(numeroPunto, fechaProgramacion) {
  return axios.get(
    `/spac/programacionPorPunto?fechaProgramacion=${fechaProgramacion}&numeroPunto=${numeroPunto}`
  );
}

function getHeaderPuntos(fechaProgramacion) {
  return axios.get(
    `/spac/programacionPorPunto/header?fechaProgramacion=${fechaProgramacion}`
  );
}

// PROGRAMACION POR CAMINOS

function getProgramacionPorCamino(codigoContrato, fechaProgramacion) {
  return axios.get(
    `/spac/programacionPorCamino?codigoContrato=${codigoContrato}&fechaProgramacion=${fechaProgramacion}`
  );
}

function getEdiCompleto(fechaProgramacion) {
  return axios.get(
    `/spac/programacionPorCamino/generarEdiCompleto?fechaProgramacion=${fechaProgramacion}`,
    {
      responseType: "text"
    }
  );
}

function getHeaderCaminos(fechaProgramacion) {
  return axios.get(
    `/spac/programacionPorCamino/header?fechaProgramacion=${fechaProgramacion}`
  );
}

function getUltimaReprogramacion() {
  return axios.get(`/spac/programacion/fechaUltimaReprogramacion`);
}

// ASIGNACION

function getUltimaFechaAsignacion() {
  return axios.get(`/spac/asignacion/fechaUltimaAsignacion`);
}

// ASIGNACION DETALLADA POR PUNTOS

function getRazonesAsignadas() {
  return axios.get(`/spac/asignacionDetallada/comboComentario`);
}

function getComboPunto(fecha) {
  return axios.get(`/spac/asignacionDetallada/comboPunto?fecha=${fecha}`);
}

function getActualizacionCombo(fecha, punto) {
  return axios.get(
    `/spac/asignacionDetallada/actualizacionCombo?fecha=${fecha}${
      punto ? "&punto=" + punto : ""
    }`
  );
}

function getListarConfirmaciones(fecha, punto) {
  return axios.get(
    `/spac/asignacionDetallada/listarConfirmaciones?fecha=${fecha}${
      punto ? "&punto=" + punto : ""
    }`
  );
}

// ASIGNACION DETALLADA POR PUNTOS ---> EDICION

function getComboComentario() {
  return axios.get(`/spac/asignacionDetallada/comboComentario`);
}

function saveAsignacionDetallada(fecha, punto, datos) {
  return axios.post(
    `/spac/asignacionDetallada?fecha=${fecha}&punto=${punto}`,
    datos
  );
}

function getComboAgregarContratos(fecha) {
  return axios.get(`/spac/asignacionDetallada/contratos?fecha=${fecha}`);
}

function getComboAgregarRoles(fecha, punto, rolPunto) {
  return axios.get(
    `/spac/asignacionDetallada/roles?fecha=${fecha}${punto ? "&punto=" + punto : ""}${rolPunto ? "&rolPunto=" + rolPunto : ""}`
  );
}

function getComboAgregarReferentes(contratoCargador, fecha, punto, rolPunto) {
  return axios.get(
    `/spac/asignacionDetallada/referentes?contratoCargador=${contratoCargador}&fecha=${fecha}&punto=${punto}&rolPunto=${rolPunto}`
  );
}

function saveFilasNuevasAsignacionDetallada(fecha, punto, datos) {
  return axios.post(
    `/spac/asignacionDetallada/agregarFila?fecha=${fecha}&punto=${punto}`,
    datos
  );
}

// ASIGNACION PARAMETRIZADA POR PUNTOS

function getPuntosActivos(fechaDesde, fechaHasta) {
  return axios.get(
    `/spac/asignacionParametrizadaPunto/puntos?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
  );
}

function getContratosPorPunto(
  fechaDesde,
  fechaHasta,
  nroEntidadLegal,
  nroPunto
) {
  return axios.get(
    `/spac/asignacionParametrizadaPunto/contratos?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      nroEntidadLegal && nroEntidadLegal !== "Todas"
        ? "&nroEntidadLegal=" + nroEntidadLegal
        : ""
    }${nroPunto ? "&nroPunto=" + nroPunto : ""}`
  );
}

function getEntidadesPorPunto(fechaDesde, fechaHasta, nroPunto, referente) {
  return axios.get(
    `/spac/asignacionParametrizadaPunto/entidadesLegales?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      nroPunto ? "&nroPunto=" + nroPunto : ""
    }${referente && referente !== "Todos" ? "&referente=" + referente : ""}`
  );
}

function getOperadorPorPunto(fechaDesde, fechaHasta, nroPunto) {
  return axios.get(
    `/spac/asignacionParametrizadaPunto/operador?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}&nroPunto=${nroPunto}`,
    {
      responseType: "text"
    }
  );
}

function getReferentesPorPuntos(
  activos,
  fechaDesde,
  fechaHasta,
  nroEntidadLegal,
  nroPunto
) {
  return axios.get(
    `/spac/asignacionParametrizadaPunto/referentes?activos=${activos}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      nroEntidadLegal && nroEntidadLegal !== "Todas"
        ? "&nroEntidadLegal=" + nroEntidadLegal
        : ""
    }${nroPunto ? "&nroPunto=" + nroPunto : ""}`
  );
}

function getDatosAsignacionPorPunto(
  codigoContrato,
  fechaDesde,
  fechaHasta,
  nroEntidadLegal,
  nroPunto,
  referente,
  rolPunto
) {
  return axios.get(
    `/spac/asignacionParametrizadaPunto/listar?${
      codigoContrato && codigoContrato !== "Todos"
        ? "codigoContrato=" + codigoContrato + "&"
        : ""
    }fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      nroEntidadLegal && nroEntidadLegal !== "Todas"
        ? "&nroEntidadLegal=" + nroEntidadLegal
        : ""
    }&nroPunto=${nroPunto}${
      referente && referente !== "Todos" ? "&referente=" + referente : ""
    }&rolPunto=${rolPunto}`
  );
}

function generarEDIParamPorPunto(data) {
  return axios.post(`/spac/asignacionParametrizadaPunto/generacionEdi`, data, {
    responseType: "text"
  });
}

function reportImprimirRefs(
  contrato,
  fechaInicial,
  fechaFinal,
  entidad,
  punto,
  activos,
  rol
) {
  return axios.get(
    `/spac/asignacionParametrizadaPunto/referentesReport?${
      contrato && contrato !== "Todos" ? "codigoContrato=" + contrato + "&" : ""
    }fechaDesde=${fechaInicial}&fechaHasta=${fechaFinal}${
      entidad && entidad !== "Todas" ? "&nroEntidadLegal=" + entidad : ""
    }&nroPunto=${punto}${
      activos ? "&referentesActivos=" + activos : ""
    }&rolPunto=${rol}`
  );
}

// ASIGNACION PARAMETRIZADA POR ZONAS

function getSociedadDefault() {
  return axios.get(`/spac/asignacionParametrizadaZona/sociedadDefault`);
}

function getSociedades() {
  return axios.get(`/spac/asignacionParametrizadaZona/sociedades`);
}

function getContratosPorZona(
  fechaDesde,
  fechaHasta,
  nroEntidadLegal,
  sociedad
) {
  return axios.get(
    `/spac/asignacionParametrizadaZona/contratos?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      nroEntidadLegal && nroEntidadLegal !== "Todas"
        ? "&nroEntidadLegal=" + nroEntidadLegal
        : ""
    }&sociedad=${sociedad}`
  );
}

function getEntidadesPorZona(sociedad) {
  return axios.get(
    `/spac/asignacionParametrizadaZona/entidadesLegales?${
      sociedad ? "sociedad=" + sociedad : ""
    }`
  );
}

function getZonasPorZona() {
  return axios.get(`/spac/asignacionParametrizadaZona/zonas`);
}

function getDatosAsignacionPorZona(
  contrato,
  entidadLegal,
  fechaFinal,
  fechaInicial,
  rol,
  sociedad,
  zona
) {
  return axios.get(
    `/spac/asignacionParametrizadaZona?${
      contrato && contrato !== "Todos" ? "contrato=" + contrato + "&" : ""
    }${
      entidadLegal && entidadLegal !== "Todas"
        ? "entidadLegal=" + entidadLegal + "&"
        : ""
    }fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}${
      rol ? "&rol=" + rol : ""
    }&sociedad=${sociedad}${zona ? "&zona=" + zona : ""}`
  );
}

function generarEDIParamPorZona(data) {
  return axios.post(`/spac/asignacionParametrizadaZona/generacionEdi`, data, {
    responseType: "text"
  });
}

// ASIGNACION PARAMETRIZADA POR ZONA-PUNTO

function getSociedadDefaultZonaPunto() {
  return axios.get(`/spac/asignacionParametrizadaZonaPunto/sociedadDefault`);
}

function getSociedadesZonaPunto() {
  return axios.get(`/spac/asignacionParametrizadaZonaPunto/sociedades`);
}

function getContratosPorZonaPunto(
  fechaDesde,
  fechaHasta,
  sociedad,
  nroEntidadLegal
) {
  return axios.get(
    `/spac/asignacionParametrizadaZonaPunto/contratos?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      nroEntidadLegal && nroEntidadLegal !== "Todas"
        ? "&nroEntidadLegal=" + nroEntidadLegal
        : ""
    }&sociedad=${sociedad}`
  );
}

function getEntidadesPorZonaPunto(fechaDesde, fechaHasta, sociedad, referente) {
  return axios.get(
    `/spac/asignacionParametrizadaZonaPunto/entidadesLegales?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      referente && referente !== "Todos" ? "&referente=" + referente : ""
    }&sociedad=${sociedad}`
  );
}

function getReferentesPorZonaPunto(
  fechaDesde,
  fechaHasta,
  sociedad,
  nroEntidadLegal
) {
  return axios.get(
    `/spac/asignacionParametrizadaZonaPunto/referentes?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}${
      nroEntidadLegal && nroEntidadLegal !== "Todas"
        ? "&nroEntidadLegal=" + nroEntidadLegal
        : ""
    }&sociedad=${sociedad}`
  );
}

function getZonasPorZonaPunto() {
  return axios.get(`/spac/asignacionParametrizadaZonaPunto/zonas`);
}

function getDatosAsignacionPorZonaPunto(
  asc,
  contrato,
  entidadLegal,
  extraQueryOperator,
  extraQueryTerms,
  fechaFinal,
  fechaInicial,
  page,
  punto,
  referente,
  rol,
  size,
  sociedad,
  sortby,
  zona
) {
  return axios.get(
    `/spac/asignacionParametrizadaZonaPunto/listado?${
      extraQueryOperator ? "extraQueryOperator=" + extraQueryOperator + "&" : ""
    }${
      extraQueryTerms
        ? "extraQueryTerms=" +
          extraQueryTerms.map((fil, i) => {
            return i === 0
              ? `${fil.campo},${fil.tipo},${fil.valor}`
              : `:${fil.campo},${fil.tipo},${fil.valor}`;
          }) +
          "&"
        : ""
    }${asc ? "asc=" + asc + "&" : ""}${
      contrato && contrato !== "Todos" ? "contrato=" + contrato + "&" : ""
    }${
      entidadLegal && entidadLegal !== "Todas"
        ? "entidadLegal=" + entidadLegal + "&"
        : ""
    }fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}${
      page ? "&page=" + page : ""
    }${punto ? "&punto=" + punto : ""}${
      referente && referente !== "Todos" ? "&referente=" + referente : ""
    }${rol && rol !== "A" ? "&rol=" + rol : ""}${size ? "&size=" + size : ""}${
      sociedad ? "&sociedad=" + sociedad : ""
    }${sortby ? "&sortby=" + sortby : ""}${zona ? "&zona=" + zona : ""}`
  );
}

function validateControlDiarioBetweenDates (
  fechaInicial,
  fechaFinal
) {
  return axios.get(
    `/spac/asignacionParametrizadaZonaPunto/validateControlDiarioBetweenDates?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`,
    {
      responseType: "text"
    }
  );
}

function generarEDIParamPorZonaPunto(data) {
  return axios.post(
    `/spac/asignacionParametrizadaZonaPunto/generacionEdi`,
    data,
    {
      responseType: "text"
    }
  );
}

// CONTROL PROYECCIONES POR PUNTO

function getProyeccionesPuntosPuntos() {
  return axios.get(`/spac/proyeccionesPorPuntos/puntos`);
}

function getProyeccionesPuntosEntidad() {
  return axios.get(`/spac/entidadesLegales/entidades-legales-rol-usuario`);
}

function getProyeccionesPuntosUpdatePuntos(fecha, nroPunto) {
  return axios.get(
    `/spac/proyeccionesPorPuntos/updatePuntos?fecha=${fecha}&nroPto=${nroPunto}`
  );
}

function generarEDIProyeccionesPuntos(data) {
  return axios.post(`/spac/proyeccionesPorPuntos/generacionEdi`, data, {
    responseType: "text"
  });
}

function listarProyeccionesPuntos(fecha, nroEntidadLegal, nroPto, rolPto) {
  return axios.get(
    `/spac/proyeccionesPorPuntos/listar?fecha=${fecha}${
      nroEntidadLegal ? "&nroEntidadLegal=" + nroEntidadLegal : ""
    }&nroPto=${nroPto}&rolPto=${rolPto}`
  );
}

// CONTROL PROYECCIONES POR PUNTO DETALLES

function generarEDIDetallesProyeccionesPuntos(data) {
  return axios.post(`/spac/proyeccionesPorPuntos/generacionEdiDetalle`, data, {
    responseType: "text"
  });
}

function getDetallesProyeccionesPuntosContratos(fecha, nroPto, rolPto) {
  return axios.get(
    `/spac/proyeccionesPorPuntos/comboContratos?fecha=${fecha}&nroPto=${nroPto}&rolPto=${rolPto}`
  );
}

function listarDetallesProyeccionesPuntos(
  contratoID,
  fecha,
  nroEntidadLegal,
  nroPto,
  rolPto
) {
  return axios.get(
    `/spac/proyeccionesPorPuntos/listarDetalle?fecha=${fecha}${!contratoID ? "" : `&contratoID=${contratoID}`}${
      nroEntidadLegal ? "&nroEntidadLegal=" + nroEntidadLegal : ""
    }&nroPto=${nroPto}&rolPto=${rolPto}`
  );
}

// CONTROL PROYECCIONES POR ZONA

function getProyeccionesZonasEntidades(sociedad) {
  return axios.get(
    `/spac/proyeccionesPorZonas/entidadesLegales?sociedad=${sociedad}`
  );
}

function getProyeccionesZonasGasoducto() {
  return axios.get(`/spac/proyeccionesPorZonas/gasoducto`);
}

function getProyeccionesZonasSociedad() {
  return axios.get(`/spac/proyeccionesPorZonas/sociedades`);
}

function getProyeccionesZonasZonas() {
  return axios.get(`/spac/proyeccionesPorZonas/zonas`);
}

function generarEDIProyeccionesZona(data) {
  return axios.post(`/spac/proyeccionesPorZonas/generacionEdi`, data, {
    responseType: "text"
  });
}

function listarProyeccionesZonas(
  cuenca,
  entidadLegal,
  fechaInicial,
  fechaFinal,
  gasoducto,
  horaFinal,
  horaInicial,
  rol,
  sociedad,
  valoresHorarios,
  zona
) {
  return axios.get(
    `/spac/proyeccionesPorZonas/listar?${
      cuenca ? "cuenca=" + cuenca + "&" : ""
    }${
      entidadLegal ? "entidadLegal=" + entidadLegal + "&" : ""
    }fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}${
      gasoducto ? "&gasoducto=" + gasoducto : ""
    }&horaFinal=${horaFinal}&horaInicial=${horaInicial}&rol=${rol}&sociedad=${sociedad}${
      valoresHorarios ? "&valoresHorarios=" + valoresHorarios : ""
    }${zona ? "&zona=" + zona : ""}`
  );
}

// VENTA DE PRODUCTORES

function getVentasProductoresProductores() {
  return axios.get(`/spac/ventasProductores/productores`);
}

function getVentasProductoresLotes(nroProductor, periodo) {
  return axios.get(
    `/spac/ventasProductores/lotes?nroProductor=${nroProductor}&periodo=${periodo}`
  );
}

function listarVentasProductores(
  extraQueryOperator,
  extraQueryTerms,
  nroProductor,
  periodo
) {
  return axios.get(
    `/spac/ventasProductores?${
      extraQueryOperator ? "extraQueryOperator=" + extraQueryOperator + "&" : ""
    }${
      extraQueryTerms
        ? "extraQueryTerms=" +
          extraQueryTerms.map((fil, i) => {
            return i === 0
              ? `${fil.campo},${fil.tipo},${fil.valor}`
              : `:${fil.campo},${fil.tipo},${fil.valor}`;
          }) +
          "&"
        : ""
    }nroProductor=${nroProductor}&periodo=${periodo}`
  );
}

function bloquearHabilitarProductor(
  nroProductor,
  periodo,
  ventasHabilitadasProductor
) {
  return axios.post(
    `/spac/ventasProductores/bloquearHablitarProductor?nroProductor=${nroProductor}&periodo=${periodo}&ventasHabilitadasProductor=${ventasHabilitadasProductor}`
  );
}

function bloquearHabilitarProductores(
  nroProductor,
  periodo,
  ventasHabilitadasProductor
) {
  return axios.post(
    `/spac/ventasProductores/bloquearHablitarProductores?${
      nroProductor ? "nroProductor=" + nroProductor + "&" : ""
    }periodo=${periodo}&ventasHabilitadasProductor=${ventasHabilitadasProductor}`
  );
}

function generarInformacionProdVentas(nroProductor, periodo) {
  return axios.post(
    `/spac/ventasProductores/generarInformacion?${
      nroProductor ? "nroProductor=" + nroProductor + "&" : ""
    }periodo=${periodo}`
  );
}

function reprocesarInformacionProdVentas(nroProductor, periodo) {
  return axios.post(
    `/spac/ventasProductores/reprocesarDatosProductores?${
      nroProductor ? "nroProductor=" + nroProductor + "&" : ""
    }periodo=${periodo}`
  );
}

function erroresInformacionProdVentas(periodo, errores) {
  return axios.post(
    `/spac/ventasProductores/erroresGenerarInfoReport?periodo=${periodo}`,
    errores,
    {
      responseType: "blob"
    }
  );
}

function generarPDFErroresImportarVentas(errores, periodo) {
  return axios.post(
    `/spac/ventasProductores/erroresImportVentasReport?periodo=${periodo}`,
    errores
  );
}

function getHistoricosVentasProductores(nroLote, nroProductor, periodo) {
  return axios.get(
    `/spac/ventasProductores/historicos?${
      nroLote ? "nroLote=" + nroLote + "&" : ""
    }&nroProductor=${nroProductor}&periodo=${periodo}`
  );
}

function importarVentasProductores(file, nroProductor, periodo) {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(
    `/spac/ventasProductores/importarVentas?nroProductor=${nroProductor}&periodo=${periodo}`,
    formData,
    {
      headers: {
        "content-type": "multipart/form-data"
      }
    }
  );
}

function erroresImportarVentas(periodo, errores) {
  return axios.post(
    `/spac/ventasProductores/erroresImportVentasReport?periodo=${periodo}`,
    errores,
    {
      responseType: "blob"
    }
  );
}

function validarPermisosVentasProductores(nroProductor, periodo) {
  return axios.get(
    `/spac/ventasProductores/valicionPermisos?${
      nroProductor ? "nroProductor=" + nroProductor + "&" : ""
    }periodo=${periodo}`
  );
}

// MANTENIMIENTO - PUNTO

function getComboPuntoMantenimiento(codigoZona) {
  const params = codigoZona ? `?codigoZona=${codigoZona}` : "";
  return axios.get(`spac/mantenimiento/puntos/comboPunto${params}`);
}

function getComboZonaMantenimiento() {
  return axios.get(`spac/mantenimiento/puntos/comboZona`);
}

function getListarMantenimientoPunto(
  asc,
  numeroPunto,
  page,
  size,
  sortby,
  zonaID
) {
  const params = {};
  const inputs = {
    asc: asc,
    numeroPunto: numeroPunto,
    page: page,
    size: size,
    sortby: sortby,
    zonaID: zonaID
  };
  const inputsValues = Object.values(inputs);
  const inputsKeys = Object.keys(inputs);
  inputsValues.forEach((value, index) => {
    if (
      (value || typeof value === "boolean") &&
      value !== "Todos" &&
      value !== "Todas"
    ) {
      Object.assign(params, { [inputsKeys[index]]: value });
    }
  });

  const url = `/spac/mantenimiento/puntos/listar?${getQueryString(params)}`;
  return axios.get(url);
}

function getReporteMantenimientoPunto(
  asc,
  numeroPunto,
  reportType,
  sortby,
  zonaID
) {
  const params = {};

  if (asc || typeof asc === "boolean") {
    Object.assign(params, { asc });
  }

  if (numeroPunto !== "Todos") {
    Object.assign(params, { numeroPunto });
  }

  if (reportType) {
    Object.assign(params, { reportType });
  }

  if (sortby) {
    Object.assign(params, { sortby });
  }

  if (zonaID) {
    Object.assign(params, { zonaID });
  }
  const url = `/etgs/api/spac/mantenimiento/puntos/report?${getQueryString(
    params
  )}`;
  return url;
}

// MANTENIMIENTO - PUNTO DETALLE

function getReporteMantenimientoPuntoDetalle(numeroPunto, reportType) {
  const params = {};

  if (numeroPunto) {
    Object.assign(params, { numeroPunto });
  }

  if (reportType) {
    Object.assign(params, { reportType });
  }
  const url = `/etgs/api/spac/mantenimiento/puntosDetalle/report?${getQueryString(
    params
  )}`;
  return url;
}

function getMantenimientoPuntoDetalle(numeroPunto) {
  return axios.get(
    `/spac/mantenimiento/puntosDetalle/detalle?numeroPunto=${numeroPunto}`
  );
}

// MANTENIMIENTO - CONTRATO

function getComboEntidadLegalMantenimientoContrato(codigoSociedad) {
  const params = !codigoSociedad || codigoSociedad === "Todas" ? "" : `?sociedad=${codigoSociedad}`;

  return axios.get(`spac/mantenimiento/contratos/comboEntidadLegal${params}`);
}

function getComboSociedadesMantenimientoContrato() {
  return axios.get(`spac/mantenimiento/contratos/comboSociedades`);
}

function getComboEstadoMantenimientoContrato() {
  return axios.get(`spac/mantenimiento/contratos/comboEstado`);
}

function getComboServicioMantenimientoContrato() {
  return axios.get(`spac/mantenimiento/contratos/comboServicio`);
}

function getListarMantenimientoContrato(
  asc,
  entidadLegal,
  sociedad,
  estadoContrato,
  fechaInicial,
  fechaFinal,
  page,
  size,
  sortby,
  tipoContrato
) {
  const inputs = {
    asc: asc,
    entidadLegal: entidadLegal,
    sociedad: sociedad,
    estadoContrato: estadoContrato,
    fechaInicial: fechaInicial,
    fechaFinal: fechaFinal,
    page: page,
    size: size,
    sortby: sortby,
    tipoContrato: tipoContrato
  };
  const params = {};
  const inputsValues = Object.values(inputs);
  const inputsKeys = Object.keys(inputs);
  inputsValues.forEach((value, index) => {
    if (
      (value || typeof value === "boolean") &&
      value !== "Todos" &&
      value !== "Todas"
    ) {
      Object.assign(params, { [inputsKeys[index]]: value });
    }
  });

  const url = `/spac/mantenimiento/contratos/listar?${getQueryString(params)}`;
  return axios.get(url);
}

function getPuedeEditarSegunProgMantenimientoContrato() {
  return axios.get(`spac/mantenimiento/contratos/puedeEditarSegunProgramacion`);
}

function getReporteMantenimientoContrato(
  asc,
  entidadLegal,
  sociedad,
  estadoContrato,
  fechaInicial,
  fechaFinal,
  reportType,
  sortby,
  tipoContrato
) {
  const inputs = {
    asc,
    entidadLegal,
    sociedad,
    estadoContrato,
    fechaInicial,
    fechaFinal,
    reportType,
    sortby,
    tipoContrato
  };
  const params = {};
  const inputsValues = Object.values(inputs);
  const inputsKeys = Object.keys(inputs);
  inputsValues.forEach((value, index) => {
    if ((value || typeof value === "boolean") && value !== "Todos") {
      Object.assign(params, { [inputsKeys[index]]: value });
    }
  });
  const url = `/etgs/api/spac/mantenimiento/contratos/report?${getQueryString(
    params
  )}`;
  return url;
}

function validateListMantenimientoContrato(datos) {
  return axios.post(`/spac/mantenimiento/contratos/validateSaveList`, datos);
}

function saveListMantenimientoContrato(datos) {
  return axios.post(`/spac/mantenimiento/contratos/saveList`, datos);
}

function transferirContratosSap(user, pass) {

  const params = { "sap-user": user, "sap-password": pass };

  const searchParams = new URLSearchParams(params);

  return axios.get(
      `/spac/mantenimiento/contratos/transferirContratosSap?${searchParams}`
  );
}

function getContratosTransferidos(nroLote) {
  return axios.get(
    `/spac/mantenimiento/contratos/obtenerContratosTransferidos?nroLoteTransferencia=${nroLote}`
  );
}

function saveContratosTransferidos(contratos, user, pass) {

  const params = { "sap-user": user, "sap-password": pass };

  const searchParams = new URLSearchParams(params);

  return axios.post(
    `/spac/mantenimiento/contratos/grabarContratosTransferidos?${searchParams}`,
    contratos
  );
}

// MANTENIMIENTO - CONTRATO DETALLE

function getMantenimientoContratoDetalle(codigoContrato) {
  return axios.get(`/spac/mantenimiento/contratosDetalle/${codigoContrato}`);
}

function getMantenimientoPuntosContratoDetalle(codigoContrato) {
  const params = codigoContrato ? `?codigoContrato=${codigoContrato}` : "";
  return axios.get(`/spac/mantenimiento/contratosDetalle/puntos${params}`);
}

function getObtenerNuevoNumeroContratoOperador(sociedad) {
  return axios.get(
    `/spac/mantenimiento/contratosDetalle/obtenerNuevoNumeroContratoOperador?sociedad=${sociedad}`
  );
}

function validatePuntoContrato(codigoContrato, data) {
  return axios.post(
    `/spac/mantenimiento/contratosDetalle/${codigoContrato}/validatePunto`,
    data
  );
}

function validateDeletePuntoContrato(codigoContrato, data) {
  return axios.post(
    `/spac/mantenimiento/contratosDetalle/${codigoContrato}/canDeletePunto`,
    data
  );
}

function getFechaInicioDisponiblePunto(numeroPunto) {
  return axios.get(
    `/spac/mantenimiento/contratosDetalle/puntos/${numeroPunto}/fechaInicial`
  );
}

function saveDetallePuntosContrato(data) {
  return axios.post("/spac/mantenimiento/contratosDetalle", data);
}

function getReporteMantenimientoDetalle(
  codigoContrato,
  type = "pdf",
  tabName = "PUNTOS"
) {
  return `/etgs/api/spac/mantenimiento/contratosDetalle/${codigoContrato}/report?reportType=${type}&tabName=${tabName}`;
}

// DESBALANCES

function entidadesDesbalances(codigoSociedad) {
  return axios.get(`/spac/desbalance/entidadesLegales`, {
    params: {
      sociedad: (codigoSociedad && codigoSociedad !== 'Todas') ? codigoSociedad : undefined
    }
  });
}

function fechasDesbalances() {
  return axios.get(`/spac/desbalance/fechas`);
}

function getSociedadesDesbalances() {
  return axios.get(`/spac/desbalance/sociedades`);
}

function getSociedadDefaultDesbalances() {
  return axios.get(`/spac/desbalance/sociedadDefault`);
}

// DESBALANCES - ENTIDADES POR DIA

function listarEntidadesPorDia(
  entidadLegal,
  fechaFinal,
  fechaInicial,
  resumido,
  codigoSociedad
) {
  return axios.get(
    `/spac/desbalancePorELPorDia?${
      entidadLegal ? "entidadLegal=" + entidadLegal + "&" : ""
    }fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&resumido=${resumido}${codigoSociedad ? "&codigoSociedad=" + codigoSociedad : ""}`
  );
}

function generarEdiEntidadesPorDia(data) {
  return axios.post(`/spac/desbalancePorELPorDia/generacionEdi`, data, {
    responseType: "text"
  });
}

// DESBALANCES - ENTIDADES POR CONTRATO

function listarEntidadesPorContrato(
  acumulado,
  entidadLegal,
  fechaFinal,
  fechaInicial,
  resumido,
  sociedad
) {
  const sociedadParam = sociedad ? "&sociedad=" + sociedad : "";
  return axios.get(
    `/spac/desbalancePorELPorContrato?&acumulado=${acumulado}${
      entidadLegal ? "&entidadLegal=" + entidadLegal : ""
    }&fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&resumido=${resumido}${sociedadParam}`
  );
}

function generarEdiEntidadesPorContrato(data) {
  return axios.post(`/spac/desbalancePorELPorContrato/generacionEdi`, data, {
    responseType: "text"
  });
}

// DESBALANCES - ENTIDADES LEGALES

function listarEntidadLegal(
  acumulado,
  fechaFinal,
  fechaInicial,
  resumido
) {
  return axios.get(
    `/spac/desbalancePorEntidadLegal?&acumulado=${acumulado}
    &fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&resumido=${resumido}`
  );
}

function reporteEntidadLegal(
  acumulado,
  fechaFinal,
  fechaInicial,
  reporType,
  resumido,
  datos,
  sociedad
) {
  return axios.post(
    `/spac/desbalancePorEntidadLegal/reporte?acumulado=${acumulado}&fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&reportType=${reporType}&resumido=${resumido}&sociedad=${sociedad}`,
    datos,
    {
      responseType: "blob"
    }
  );
}

function generarEdiEntidadLegal(ediData) {
  return axios.post(`/spac/desbalancePorEntidadLegal/generacionEdi`, ediData, {
    responseType: "text"
  });
}

// DESBALANCES - POR ZONA RECEPCION

function listarZonasRecepcion(contrato, fecha) {
  return axios.get(
    `/spac/desbalancePorZonaRecepcion?contrato=${contrato}&fecha=${fecha}`
  );
}

function comboContratosZonaRecepcion(fecha) {
  return axios.get(`/spac/desbalancePorZonaRecepcion/contratos?fecha=${fecha}`);
}

function generarEdiZonaRecepcion(data) {
  return axios.post(`/spac/desbalancePorZonaRecepcion/generacionEdi`, data, {
    responseType: "text"
  });
}

function generarEdiCompletoZonaRecepcion(data) {
  return axios.post(
    `/spac/desbalancePorZonaRecepcion/generacionEdiCompleto`,
    data,
    {
      responseType: "text"
    }
  );
}

// DESBALANCES - POR CAMINO CONTRATO

function listarCaminosContratos(
  contrato,
  entidadLegal,
  fechaFinal,
  fechaInicial,
  zonaEntrega,
  zonaRecepcion,
  sociedad
) {
  return axios.get(
    `/spac/desbalancePorCaminoPorContrato?${
      contrato ? "contrato=" + contrato + "&" : ""
    }entidadLegal=${entidadLegal}&fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}${
      zonaEntrega ? "&zonaEntrega=" + zonaEntrega : ""
    }${zonaRecepcion ? "&zonaRecepcion=" + zonaRecepcion : ""}${
      sociedad ? "&sociedad=" + sociedad : ""
    }`
  );
}

function comboEntidadesCaminosContratos(sociedad) {
  const sociedadParam = sociedad && sociedad !== "Todas" ? `?sociedad=${sociedad}` : "";
  return axios.get(`/spac/desbalance/entidadesLegales${sociedadParam}`);
}

function comboContratosCaminosContratos(
  entidadLegal,
  fechaFinal,
  fechaInicial,
  sociedad
) {
  const sociedadParam = sociedad && sociedad !== "Todas" ? `&sociedad=${sociedad}` : "";
  return axios.get(
    `/spac/desbalancePorCaminoPorContrato/contratos?entidadLegal=${entidadLegal}&fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}${sociedadParam}`
  );
}

function comboCaminosCaminosContratos(
  contrato,
  entidadLegal,
  fechaFinal,
  fechaInicial,
  sociedad
) {
  const sociedadParam = sociedad && sociedad !== "Todas" ? `&sociedad=${sociedad}` : "";
  return axios.get(
    `/spac/desbalancePorCaminoPorContrato/caminos?${
      contrato ? "contrato=" + contrato + "&" : ""
    }entidadLegal=${entidadLegal}&fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}${sociedadParam}`
  );
}

function generarEDICaminosContratos(data) {
  return axios.post(
    `/spac/desbalancePorCaminoPorContrato/generacionEdi`,
    data,
    {
      responseType: "text"
    }
  );
}

function generarEDICompletoCaminosContratos(data) {
  return axios.post(
    `/spac/desbalancePorCaminoPorContrato/generacionEdiCompleto`,
    data,
    {
      responseType: "text"
    }
  );
}

// DESBALANCES - AJUSTES

function getComboAlContratos(fechaFinal, fechaInicial) {
  return axios.get(
    `/spac/desbalanceAjuste/alContratos?fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}`
  );
}

function getComboContratos(fechaFinal, fechaInicial, sociedad) {
  return axios.get(
    `/spac/desbalanceAjuste/contratos?fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&sociedad=${sociedad}`
  );
}

function getComboTipoAjustes(rtp) {
  return axios.get(`/spac/desbalanceAjuste/tipoAjustes?rtp=${rtp}`);
}

function getComboTipoAjustesTR(rtp) {
  return axios.get(`/spac/desbalanceAjuste/tipoAjustesTR?rtp=${rtp}`);
}

function getComboZonas(contrato, fecha) {
  return axios.get(
    `/spac/desbalanceAjuste/zonas?contrato=${contrato}&fecha=${fecha}`
  );
}

function validarAceptarEditar(alContrato, contrato, tipoAjuste) {
  return axios.get(
    `/spac/desbalanceAjuste/validarAceptarEditar?${
      alContrato ? "alContrato=" + alContrato + "&" : ""
    }${contrato ? "contrato=" + contrato + "&" : ""}${
      tipoAjuste ? "tipoAjuste=" + tipoAjuste : ""
    }`
  );
}

function validarZonaRecepcion(fecha, codContrato, zonaRecepcion) {
  return axios.get(`/spac/desbalanceAjuste/validarZonaRecepcion?fecha=${fecha}&contrato=${codContrato}&zonaRecepcion=${zonaRecepcion}`);
}

function validarEliminar(fecha) {
  return axios.get(`/spac/desbalanceAjuste/validarEliminar?fecha=${fecha}`);
}

function validarEstadoFacturacion(fecha) {
  return axios.get(
    `/spac/desbalanceAjuste/validarEstadoFacturacion?fecha=${fecha}`
  );
}

// DESBALANCES - AJUSTES DESBALANCES

function listarAjustesDesbalances(entidad, fechaFinal, fechaInicial, sociedad) {
  return axios.get(
    `/spac/desbalanceAjustesDeDesbalances?${
      entidad && entidad != 'Todas' ? "entidadLegal=" + entidad + "&" : ""
    }fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&sociedad=${sociedad}`
  );
}

function getComboComprador() {
  return axios.get(`/spac/desbalanceAjustesDeDesbalances/comprador`);
}

function generarEDIAjustesDesbalances(data) {
  return axios.post(`/spac/desbalanceAjustesDeDesbalances/edi`, data, {
    responseType: "text"
  });
}

function saveAjustesDesbalances(datos) {
  return axios.post(`/spac/desbalanceAjustesDeDesbalances/grabar`, datos);
}

function getComboReferentes() {
  return axios.get(`/spac/desbalanceAjustesDeDesbalances/referentes`);
}

function getComboTipoComprador() {
  return axios.get(`/spac/desbalanceAjustesDeDesbalances/tipoComprador`);
}

function getComboTiposGas() {
  return axios.get(`/spac/desbalanceAjustesDeDesbalances/tipoGas`);
}

function validarAceptarEdicionDesbalances(
  estadoFacturacionHabilitado,
  fechaFinal,
  fechaInicial,
  ajuste,
  isNew
) {
  return axios.post(
    `/spac/desbalanceAjustesDeDesbalances/validarAceptarEdicion?estadoFacturacionHabilitado=${estadoFacturacionHabilitado}&fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&isNew=${isNew}`,
    ajuste
  );
}

// DESBALANCES - AJUSTES COMBUSTIBLE

function listarAjustesCombustible(entidad, fechaFinal, fechaInicial, sociedad) {
  return axios.get(
    `/spac/ajusteRTPYCombustible?${
      entidad && entidad !='Todas' ? "entidadLegal=" + entidad + "&" : ""
    }fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&sociedad=${sociedad}`
  );
}

function copiarAnteayer(entidad, sociedad) {
  return axios.get(
    `/spac/ajusteRTPYCombustible/copiAnteayer?sociedad=${sociedad}`
  );
}

function generarEDIAjustesCombustible(data) {
  return axios.post(`/spac/ajusteRTPYCombustible/edi`, data, {
    responseType: "text"
  });
}

function saveAjustesCombustible(datos) {
  return axios.post(`/spac/ajusteRTPYCombustible/grabar`, datos);
}

// REPORTES

function getComboReportes(modulo) {
  return axios.get(`/spac/reportes/comboreportes?modulo=${modulo}`);
}

function getComboEntidades(fechaInicial, fechaFinal, sociedad) {
  return axios.get(
    `/spac/reportes/entidadlegal?fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}&sociedad=${sociedad}`
  );
}

function getComboSociedades(fechaInicial, fechaFinal) {
  return axios.get(
    `/spac/reportes/sociedad?fechaFinal=${fechaFinal}&fechaInicial=${fechaInicial}`
  );
}

function getFechasReportes() {
  return axios.get("/spac/reportes/fechas");
}

function validarFechaFinalReportes(fecha) {
  return axios.get(`/spac/reportes/validarFechaFinal?fechaFinal=${fecha}`)
}


// Facturación - Provisión / Facturación  --------------------------------------------------------------------------------------

// function getComboProvisionPeriodo() {
//   return axios.get(`/spac/facturacion/provision/periodosAProvisionar`);
// }

// function requestprovisionData(year, month){
//   return axios.post(`spac/facturacion/provision/generarProvision?periodo=${year}%2F${month}`)
//   //URL mock --------------------------
//   //return axios.post(`/spac/facturacion/provision/mockGenerarProvision?periodo=2022%2F09`)
// }

// function getComboDisponibles(){
//   return axios.get(`/spac/facturacion/facturacion/disponibles`);
//   //URL mock --------------------------
//   //return axios.get(`/spac/facturacion/facturacion/disponiblesMock`);
// }

// function getComboEnRevision(){
//   return axios.get(`/spac/facturacion/facturacion/enRevision`);
//   //URL mock --------------------------
//   //return axios.get(`/spac/facturacion/facturacion/enRevisionMock`);
// }

// function getComboTransferidos(){
//   return axios.get(`/spac/facturacion/facturacion/transferibles`);
//   //URL mock --------------------------
//   //return axios.get(`/spac/facturacion/facturacion/transferiblesMock`);
// }

// function cerrarPeriodo(year, month){
//   return axios.post(`spac/facturacion/facturacion/cerrarPeriodo?periodo=${year}%2F${month}`)
//   //URL mock --------------------------
//   //return axios.post(`/spac/facturacion/facturacion/cerrarPeriodoMock?periodo=${year}%2F${month}`)
// }

// function cancelarCierre(year, month){
//   return axios.post(`spac/facturacion/facturacion/CancelarCierre?periodo=${year}%2F${month}`)
// }

// function generarArchivo(data, tablaIndex, formato){
//   const tabla = tablaIndex === 0 ? "facturacionOriginal" : "facturacionAperturaImpositiva"
//   return axios({
//     url: `/spac/facturacion/provision/generarReporte/${tabla}/${formato}`,
//     data: data,    
//     method: 'POST',
//     responseType: 'blob', // important
//   }).then((response) => {
//     // create file link in browser's memory  
//     const href = URL.createObjectURL(response);
//     // create "a" HTML element with href to file & click    
//     const link = document.createElement('a');
//     link.href = href;
//     link.setAttribute('download', `${tabla}.${formato}`); //or any other extension    
//     document.body.appendChild(link);

//     formato === "print" ? window.open(href, "_blank") : link.click();

//     URL.revokeObjectURL(href);
//   });
// }

// function transferirProvisionSAP(data) {
//   return axios.post('/spac/facturacion/provision/transferirProvisionASAP', data)

// }

// function CancelarTransferenciaSAP(data) {
//   //return axios.post('/spac/facturacion/facturacion/CancelarTransferencia', data) 
//   //primero hago estoo
//   //URL mock --------------------------
//   return axios.post('/spac/facturacion/facturacion/CancelarTransferenciaMock', data)  
// }


// function finalizarTransferenciaSAP(data) {
//   return axios.post('/spac/facturacion/facturacion/finalizarTransferencia', data) 

//   //ESTO NO TIENE MOCK
// }



// function transferirFacturacionSAP(data) {
//   //FALTA URL POSTA PREGUNTAR A PABLO
//   //URL mock --------------------------
//   return axios.post('/spac/facturacion/facturacion/TransferirSAPMock', data)
//}

// Facturación - Provisión / Facturación  --------------------------------------------------------------------------------------

// Facturación - Provisión / Facturación  -------------------------------------------------------------------------------------

function listarConfiguracionRutasBases(fechaVigencia){

  return axios.get(`/spac/mantenimiento/porcentaje-combustible/config-rutas-base?fechaCierre=${fechaVigencia}`)

}

function saveRutasBases(datos) {
  return axios.post(`/spac/mantenimiento/porcentaje-combustible/registrar-rutas-base`, datos);
}

function calcularRutasIntermedias(fechaVigencia){
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/calcular-rutas-intermedias?fechaCierre=${fechaVigencia}`)
}


function getReporteRutasIntermedias(type,dataReporte, reportTitle, reportName) {
  return axios.post(`/spac/mantenimiento/porcentaje-combustible/generarRutasReport?reportType=${type}&reportTitle=${reportTitle}&reportName=${reportName}`, dataReporte,
  {
    responseType: "blob"
  }
  );
}

function getZonasRecepcion(){
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/listar-zonas-recepcion`)
}

function getZonasEntregas(){
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/listar-zonas-entrega`)
}

function consultarPorcentajeCombustible(fechaDesde, fechaHasta, zonaRecepcion, zonaEntrega, rutaBase, rutaIntermedia, gasLink, tf, ti, ed) {

let url = `/spac/mantenimiento/porcentaje-combustible/consultar-porcentaje-combustible
?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}&zonaRecepcion=${zonaRecepcion}&zonaEntrega=${zonaEntrega}
&rutaBase=${rutaBase}&rutaIntermedia=${rutaIntermedia}&gasLink=${gasLink}&tf=${tf}&ti=${ti}&ed=${ed}`

  return axios.get(url)
}

function consultarPorcentajeCombustibleRutasVigentes() {
  return axios.get('/spac/mantenimiento/porcentaje-combustible/consultar-porcentaje-combustible-rutas-vigentes')
}

function getZonasRecepcionPorRol(){
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/listar-zonas-recepcion-por-rol`)
}

function getZonasEntregaPorRol(){
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/listar-zonas-entrega-por-rol`)
}

function getTipoServicios(){
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/listar-tipo-servicio`)
}

function getConfiguracionRutas(fechaVigencia, tipoServicio, zonaRecepcion, zonaEntrega) {
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/config-rutas?fechaVigencia=${fechaVigencia}&tipoServicio=${tipoServicio}&zonaRecepcion=${zonaRecepcion}&zonaEntrega=${zonaEntrega}`)
}

function saveRutasGlee(datos) {
  return axios.post(`/spac/mantenimiento/porcentaje-combustible/registrar-rutas-glee`, datos);
}

function postRuta(ruta) {
  return axios.post(`/spac/mantenimiento/porcentaje-combustible/registrar-alta-ruta`, ruta);
}

function checkRouteModification(ruta) {
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/check-route-modification`, {
    params: ruta
  });
}

function getRutas() {
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/get-rutas`);
}

function getConfigRutasIntermedias() {
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/rutas-intermedias`);
}

function updateFormulasRutasIntermedias(data) {
  return axios.patch(`/spac/mantenimiento/porcentaje-combustible/rutas-intermedias`, data);
}

function getConfigRutasBase() {
  return axios.get(`/spac/mantenimiento/porcentaje-combustible/rutas-base`);
}

function updateRutasBase(data) {
  return axios.patch(`/spac/mantenimiento/porcentaje-combustible/rutas-base`, data);
}



export default {
  getContratosEntidades,
  getSolicitudesSociedades,
  getSolicitudesEnHora,
  getSolicitudesFueraDeHora,
  getDetalleSolicitud,
  validarCaminos,
  validarCamino,
  getEDI,
  deleteSolicitud,
  copySolicitud,
  actualizarCopiaSolicitud,
  saveSolicitud,
  checkContratoActivo,
  getCaminos,
  getPuntos,
  getPuntosByZonaTipoZonaAndFechas,
  getReferentes,
  getReferentesConfirmaciones,
  importEdiSolicitudes,
  reportSolicitudesEdi,
  postSaveLote,
  getContratosOperadores,
  getEntidadesLegales,
  getConfirmacionesEnHora,
  getConfirmacionesFueraDeHora,
  generarEDIC,
  deleteConfirmaciones,
  importEdiConfirmaciones,
  reportConfirmacionEdi,
  saveConfirmacionEdi,
  getDetalleConfirmacion,
  copyConfirmacion,
  getPuntosConfirmacion,
  saveConfirmacion,
  getContratosCargadores,
  getCantidadesSolicitadas,
  getTipoSeleccionContrato,
  getTipoSeleccionContratoCantidadeswithpunto,
  erroresMeg,
  getPuntosAsignacion,
  generarEDIAsignacion,
  getHistoricosCapacidadPuntos,
  getHistoricosConfirmacion,
  generarEDIConfirmaciones,
  getHistoricosContratos,
  getHistoricosLotes,
  getHistoricosProgramacionCaminos,
  generarEDICaminos,
  getHistoricosProgramacionPuntos,
  getHistoricosPuntos,
  getHistoricosSolicitud,
  generarEDISolicitudes,
  getProgramacionPorCamino,
  getEdiCompleto,
  getHeaderCaminos,
  getProgramacionPorPunto,
  getHeaderPuntos,
  getUltimaReprogramacion,
  getUltimaFechaAsignacion,
  getRazonesAsignadas,
  getComboPunto,
  getActualizacionCombo,
  getListarConfirmaciones,
  getComboComentario,
  saveAsignacionDetallada,
  getComboAgregarContratos,
  getComboAgregarRoles,
  getComboAgregarReferentes,
  saveFilasNuevasAsignacionDetallada,
  getContratosPorPunto,
  getEntidadesPorPunto,
  getDatosAsignacionPorPunto,
  getOperadorPorPunto,
  getPuntosActivos,
  getReferentesPorPuntos,
  generarEDIParamPorPunto,
  reportImprimirRefs,
  getSociedadDefault,
  getSociedades,
  getContratosPorZona,
  getEntidadesPorZona,
  getZonasPorZona,
  getDatosAsignacionPorZona,
  generarEDIParamPorZona,
  getSociedadDefaultZonaPunto,
  getSociedadesZonaPunto,
  getContratosPorZonaPunto,
  getEntidadesPorZonaPunto,
  getReferentesPorZonaPunto,
  getZonasPorZonaPunto,
  getDatosAsignacionPorZonaPunto,
  validateControlDiarioBetweenDates,
  generarEDIParamPorZonaPunto,
  getProyeccionesPuntosPuntos,
  getProyeccionesPuntosEntidad,
  getProyeccionesPuntosUpdatePuntos,
  generarEDIProyeccionesPuntos,
  listarProyeccionesPuntos,
  generarEDIDetallesProyeccionesPuntos,
  getDetallesProyeccionesPuntosContratos,
  listarDetallesProyeccionesPuntos,
  getProyeccionesZonasEntidades,
  getProyeccionesZonasGasoducto,
  getProyeccionesZonasSociedad,
  getProyeccionesZonasZonas,
  generarEDIProyeccionesZona,
  listarProyeccionesZonas,
  listarVentasProductores,
  bloquearHabilitarProductor,
  bloquearHabilitarProductores,
  generarInformacionProdVentas,
  reprocesarInformacionProdVentas,
  erroresInformacionProdVentas,
  generarPDFErroresImportarVentas,
  getHistoricosVentasProductores,
  importarVentasProductores,
  erroresImportarVentas,
  getVentasProductoresLotes,
  getVentasProductoresProductores,
  validarPermisosVentasProductores,
  getComboPuntoMantenimiento,
  getComboZonaMantenimiento,
  getListarMantenimientoPunto,
  getReporteMantenimientoPunto,
  getReporteMantenimientoPuntoDetalle,
  getMantenimientoPuntoDetalle,
  entidadesDesbalances,
  fechasDesbalances,
  listarEntidadesPorDia,
  generarEdiEntidadesPorDia,
  listarEntidadesPorContrato,
  listarEntidadLegal,
  reporteEntidadLegal,
  generarEdiEntidadLegal,
  generarEdiEntidadesPorContrato,
  listarZonasRecepcion,
  comboContratosZonaRecepcion,
  generarEdiZonaRecepcion,
  generarEdiCompletoZonaRecepcion,
  listarCaminosContratos,
  comboCaminosCaminosContratos,
  comboEntidadesCaminosContratos,
  comboContratosCaminosContratos,
  generarEDICaminosContratos,
  generarEDICompletoCaminosContratos,
  getComboEntidadLegalMantenimientoContrato,
  getComboSociedadesMantenimientoContrato,
  getComboEstadoMantenimientoContrato,
  getComboServicioMantenimientoContrato,
  getListarMantenimientoContrato,
  getPuedeEditarSegunProgMantenimientoContrato,
  getReporteMantenimientoContrato,
  validateListMantenimientoContrato,
  saveListMantenimientoContrato,
  getMantenimientoContratoDetalle,
  getMantenimientoPuntosContratoDetalle,
  getComboAlContratos,
  getComboContratos,
  getComboTipoAjustes,
  getComboTipoAjustesTR,
  validarAceptarEditar,
  validarEliminar,
  validarEstadoFacturacion,
  getComboZonas,
  listarAjustesDesbalances,
  getSociedadesDesbalances,
  getSociedadDefaultDesbalances,
  getComboComprador,
  generarEDIAjustesDesbalances,
  saveAjustesDesbalances,
  getComboReferentes,
  getComboTipoComprador,
  getComboTiposGas,
  validarAceptarEdicionDesbalances,
  validarZonaRecepcion,
  listarAjustesCombustible,
  copiarAnteayer,
  generarEDIAjustesCombustible,
  saveAjustesCombustible,
  getComboReportes,
  getFechasReportes,
  getComboEntidades,
  getComboSociedades,
  getObtenerNuevoNumeroContratoOperador,
  validatePuntoContrato,
  saveDetallePuntosContrato,
  validateDeletePuntoContrato,
  getFechaInicioDisponiblePunto,
  transferirContratosSap,
  getContratosTransferidos,
  saveContratosTransferidos,
  getReporteMantenimientoDetalle,
  validarFechaFinalReportes,
  // getComboProvisionPeriodo,
  // requestprovisionData,
  // generarArchivo,
  // getComboDisponibles,
  // getComboEnRevision,
  // getComboTransferidos,
  // cerrarPeriodo,
  // cancelarCierre,
  // transferirProvisionSAP,
  // CancelarTransferenciaSAP,
  // finalizarTransferenciaSAP,
  // transferirFacturacionSAP,
  listarConfiguracionRutasBases,
  saveRutasBases,
  calcularRutasIntermedias,
  getReporteRutasIntermedias,
  getZonasRecepcion,
  getZonasEntregas,
  consultarPorcentajeCombustible,
  consultarPorcentajeCombustibleRutasVigentes,
  getTipoServicios,
  getConfiguracionRutas,
  saveRutasGlee,
  postRuta,
  getRutas,
  checkRouteModification,
  getConfigRutasIntermedias,
  updateFormulasRutasIntermedias,
  getConfigRutasBase,
  updateRutasBase,
  getSociedadesConfirmaciones,
  getEntidadesLegalesConfirmaciones,
  getZonasEntregaPorRol,
  getZonasRecepcionPorRol
};
